import React, {useContext, useState, Fragment} from 'react';
import {navigate} from 'gatsby';
import {Alert, message, Form, Tabs} from 'antd';
import styled from 'styled-components';

import {Context} from '../AppContext';
import {Input, Button, Divider, Text, Link, Row} from '../Widgets';
import Image from '../Components/Image';
import {ErrLogin, errorHandler} from '../errors';

const config = require('../data.json');

// function errorHandler(ex) {
//   console.warn(ex);

//   // if(ex && ex.error === "user_not_found") {
//   //   message.warning("查無此使用者");
//   // }
// }

const UISTATE = {
  normal: 'normal',
  enterprise: 'enterprise',
};

const items = [
  {
    label: '一般會員',
    key: UISTATE.normal,
  },
  {
    label: '企業會員',
    key: UISTATE.enterprise,
  },
];

export default function Login(props) {
  const [uiState, setUiState] = useState(UISTATE.normal);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const app = useContext(Context);

  const handleTabsChange = (e) => {
    setUiState(e);
  };

  const [form] = Form.useForm();

  const login = async (values) => {
    const {email, password, gui_number} = values;

    setLoading(true);

    let payload = {
      username: email,
      password,
    };

    if (uiState === UISTATE.enterprise) {
      payload = {...payload, gui_number};
    }

    try {
      const resp = await app.actions.login(payload);
      app.actions.getCart();
      app.actions.setModal(null);
      const bind = resp.bind;
      if (bind) {
        navigate('/profile?login=email');
      }
    } catch (ex) {
      if (ex.error === 'user_type_error') {
        ex = new ErrLogin('此帳號非此會員類型，請選擇正確的類型');
      } else {
        setError(true);
      }

      errorHandler(ex, '登入失敗');
    }
    setLoading(false);
  };

  return (
    <Wrapper>
      <Image
        src="/images/logo.svg"
        alt="logo"
        style={{width: 150, margin: 'auto'}}
      />
      <Row
        style={{
          justifyContent: 'center',
          flexDirection: 'column',
          marginBottom: 0,
        }}>
        <Text
          color="#000"
          weight="700"
          style={{
            fontSize: 32,
            lineHeight: '36px',
            letterSpacing: -0.64,
            marginBottom: 18,
          }}>
          歡迎登入
        </Text>
        <Row style={{justifyContent: 'center', marginBottom: 0}}>
          <Text size="md" color="#5B616E">
            還不是會員嗎？
          </Text>
          <Link
            to="/register"
            onClick={() => {
              app.actions.setModal(null);
              app.actions.setEnterpriseRegister(false);
            }}
            style={{color: config.designsTheme.primary}}>
            <Text
              size="md"
              color={config.designsTheme.primary}
              weight="700"
              style={{
                textDecoration: 'underline',
                textUnderlineOffset: 8,
              }}>
              立即註冊
            </Text>
          </Link>
        </Row>
      </Row>

      {/* {error && (
        <Alert
          message="登入失敗"
          description={'請重新確認您的信箱與密碼，然後再試一次'}
          type="error"
          showIcon
          style={{marginBottom: 10}}
        />
      )} */}

      <div style={{display: 'flex', flexDirection: 'column', gap: 20}}>
        <div style={{display: 'flex'}}>
          <Tabs
            defaultActiveKey={UISTATE.normal}
            items={items}
            onChange={handleTabsChange}
          />
        </div>

        {uiState === UISTATE.normal ? (
          <Form form={form} name={UISTATE.normal} onFinish={login}>
            <Row
              style={{
                marginBottom: 4,
              }}>
              <StyledFormItem
                name="email"
                rules={[
                  {required: true, message: '信箱必填'},
                  {
                    type: 'email',
                    message: '電子郵件格式有誤，請重新輸入',
                  },
                ]}
                validateTrigger="onBlur">
                <StyledInput
                  id="login-username-input"
                  placeholder="請輸入信箱"
                />
              </StyledFormItem>
            </Row>

            <Row
              style={{
                marginBottom: 20,
                position: 'relative',
              }}>
              <StyledFormItem
                name="password"
                rules={[{required: true, message: '密碼必填'}]}>
                <Input.Password
                  id="login-password-input"
                  placeholder="請輸入密碼"
                  type="password"
                  style={{
                    padding: '10px 12px',
                    flex: 1,
                    margin: 0,
                    borderRadius: 8,
                    fontSize: 16,
                  }}
                />
              </StyledFormItem>

              {error && (
                <Text
                  size="sm"
                  weight="500"
                  style={{
                    color: config.colors.emphasize,
                    position: 'absolute',
                    left: 0,
                    bottom: '3px',
                  }}>
                  帳號密碼有誤，請重新檢查後再次輸入
                </Text>
              )}
              <Link
                to="/fgpass"
                onClick={() => app.actions.setModal(null)}
                style={{
                  marginLeft: 'auto',
                  position: 'absolute',
                  right: 0,
                  bottom: '3px',
                }}>
                <Text
                  size="sm"
                  weight="500"
                  style={{color: config.designsTheme.primary}}>
                  忘記密碼？
                </Text>
              </Link>
            </Row>
            <Form.Item>
              <StyledButton
                htmlType="button"
                onClick={() => form.submit()}
                loading={loading}>
                登入
              </StyledButton>
            </Form.Item>
          </Form>
        ) : (
          <Form form={form} name={UISTATE.enterprise} onFinish={login}>
            <Row
              style={{
                marginBottom: 4,
              }}>
              <StyledFormItem
                name="gui_number"
                rules={[{required: true, message: '統編必填'}]}>
                <StyledInput
                  id="login-gui-number-input"
                  placeholder="請輸入統編"
                />
              </StyledFormItem>
            </Row>

            <Row
              style={{
                marginBottom: 4,
              }}>
              <StyledFormItem
                name="email"
                rules={[{required: true, message: '信箱必填'}]}>
                <StyledInput
                  id="login-username-input"
                  placeholder="請輸入信箱"
                />
              </StyledFormItem>
            </Row>

            <Row
              style={{
                marginBottom: 20,
                position: 'relative',
              }}>
              <StyledFormItem
                name="password"
                rules={[{required: true, message: '密碼必填'}]}>
                <Input.Password
                  id="login-password-input"
                  placeholder="請輸入密碼"
                  type="password"
                  style={{
                    padding: '10px 12px',
                    flex: 1,
                    margin: 0,
                    borderRadius: 8,
                    fontSize: 16,
                  }}
                />
              </StyledFormItem>

              {error && (
                <Text
                  size="sm"
                  weight="500"
                  style={{
                    color: config.colors.emphasize,
                    position: 'absolute',
                    left: 0,
                    bottom: '3px',
                  }}>
                  帳號密碼有誤，請重新檢查後再次輸入
                </Text>
              )}
              <Link
                to="/fgpass"
                onClick={() => app.actions.setModal(null)}
                style={{
                  marginLeft: 'auto',
                  position: 'absolute',
                  right: 0,
                  bottom: '3px',
                }}>
                <Text
                  size="sm"
                  weight="500"
                  style={{color: config.designsTheme.primary}}>
                  忘記密碼？
                </Text>
              </Link>
            </Row>
            <Form.Item>
              <StyledButton
                htmlType="button"
                onClick={() => form.submit()}
                loading={loading}>
                登入
              </StyledButton>
            </Form.Item>
          </Form>
        )}
      </div>

      <Divider>
        <Text size="md">使用以下帳號快速登入</Text>
      </Divider>

      <Row
        style={{
          justifyContent: 'center',
          marginBottom: 0,
        }}>
        <SocialSignInBtn>
          <Image
            alt="social signin - facebook"
            linkto={`${config.endpoint.apiHost}/auth/facebook`}
            src="/images/socialsign-facebook.png"
            style={{width: 28, height: 28}}
          />
        </SocialSignInBtn>

        <SocialSignInBtn>
          <Image
            alt="social signin - google"
            linkto={`${config.endpoint.apiHost}/auth/google`}
            src="/images/socialsign-google.png"
            style={{width: 28, height: 28}}
          />
        </SocialSignInBtn>

        <SocialSignInBtn>
          <Image
            alt="social signin - line"
            linkto={`${config.endpoint.apiHost}/auth/line`}
            src="/images/socialsign-line.png"
            style={{width: 28, height: 28}}
          />
        </SocialSignInBtn>
      </Row>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 24px;

  .ant-tabs-nav {
    margin-bottom: 0;
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #25272c;
  }

  .ant-tabs-tab + .ant-tabs-tab {
    margin-left: 20px;
  }

  [class^='ant-tabs'] {
    font-size: 16px;
  }
`;

const SocialSignInBtn = styled.div`
  display: block;
  width: 56px;
  height: 56px;
  border-radius: 12px;
  border: 1px solid #dbdbdf;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px 10px;

  & img {
    width: 28px;
    height: 28px;
  }

  ${(props) => props.css || ''}
`;

const StyledFormItem = styled(Form.Item)`
  width: 100%;
  margin-bottom: 25px;
`;

const StyledButton = styled(Button)`
  align-self: stretch;
  border-radius: 10px;
  width: 100%;
  font-size: 16px;
  height: 48px;
`;

const StyledInput = styled(Input)`
  padding: 10px 12px;
  flex: 1;
  margin: 0;
  border-radius: 8px;
  font-size: 16px;
`;

const metadata = {
  title: false,
  width: '480px',
  destroyOnClose: true,
};

export {metadata};
